<template>
  <CustomPanel ref="panel" :title="'基础信息'" :contentStyle="contentStyle" :closeOnPressEscape="false" class="apiMarkerAttribute" v-show="visible" @onClose="close">
    <!-- <div slot="header" class="top-tab">
      <div class="tab-header" :class="activeTab===1?'active':''" @click="activeTab=1">基础信息</div>
    </div> -->
    <div class="content" slot="content" ref="infoContent" v-show="activeTab===1">
      <div ref="detailContent" class="formContainer">
        <div class="attribute-item2">
          <div class="title">所属图层：</div>
          <div class="value" >{{getLayerName(formInline.selectedLayer)}}</div>
        </div>
        <div class="attribute-item2">
          <div class="title">标注名称：</div>
          <div class="value" >{{formInline.markerName}}</div>
        </div>
        <div class="space-line" v-show="filteredProperty.length>0"></div>
        <div class="attribute-item2" v-for="(headerItem, index) in formInline.properties" :key="index" v-show="headerItem.display" style="transform: translateX(-0.05rem)">
          <el-tooltip :content="headerItem.name" placement="top" effect="light" :open-delay="1000">
            <div class="title">{{headerItem.name}}</div>
          </el-tooltip>
          <div class="title2">：</div>
          <div class="value" :class="((headerItem.type === 'LIVE'||headerItem.type === 'LINK') && headerItem.value) ? 'link':''" @click="onClickItem(headerItem)">{{formatValue(headerItem)}}</div>
        </div>
        <div v-if="markerType==='POINT'">
          <div class="space-line"></div>
          <div class="point-item">
            <div class="name-tag">坐标点</div>
            <p></p>
            <div class="attribute-item2">
              <div class="title">经度_WGS84：</div>
              <div class="value" >{{formInline.pointLon}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">纬度_WGS84：</div>
              <div class="value" >{{formInline.pointLat}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">高度_WGS84：</div>
              <div class="value" >{{formInline.pointHeight}}米</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CustomPanel>
</template>

<script>
import CustomPanel from '@/components/CustomPanel'
import { mapGetters } from 'vuex'
import { dataset2table, coordTransform } from '@/utils/util'
export default {
  name: 'ApiMarkerAttribute',
  components: {
    CustomPanel
  },
  inject: ['shared'],
  computed: {
    ...mapGetters(['isShowSpaceTool', 'layerList', 'apiSourceDatas']),
    // 过滤不显示的属性
    filteredProperty () {
      return this.formInline.properties.filter(item => {
        return item.display
      })
    }
  },
  watch: {
    visible (val) {
      this.$store.dispatch('setDrawState', val)
    },
    apiSourceDatas (val) {
      if (val) {
        this.updateMarkerDetails()
      }
    }
  },
  beforeDestroy () {
    this.clear()
  },
  data () {
    return {
      contentStyle: {
        height: 'auto'
      },
      visible: false,

      activeTab: 1,

      formInline: {
        dateId: undefined,
        selectedLayer: undefined,
        markerName: undefined,
        // 点标注位置
        pointLon: 0,
        pointLat: 0,
        pointHeight: 0,
        // 线面节点
        gisPoints: [],
        // 自定义属性头
        properties: []
      },
      // 标注类型
      markerType: undefined,
      drawMode: undefined,

      gisHeader: {
        lonHeader: undefined,
        latHeader: undefined,
        nameHeader: undefined,
        heightHeader: undefined
      },
      isImageUploading: false,
      isVideoUploading: false,
      loading: false,
      // 是否需求成果数据
      demandData: false
    }
  },
  methods: {
    show (data) {
      this.visible = true
      this.markerType = 'POINT'
      this.formInline.selectedLayer = data.layerId
      this.formInline.dataId = data.id
      this.updateMarkerDetails()
      // 展开界面并置顶
      this.$refs.panel.unFold(true)
      this.$refs.panel.top()
    },
    // 更新标注详情
    async updateMarkerDetails () {
      if (!this.visible) {
        return
      }
      const layer = this.layerList.find(item => { return item.id === this.formInline.selectedLayer })
      const config = JSON.parse(layer.config)
      this.formInline.properties = config.tableProperties
      this.formInline.config = config
      if (!this.apiSourceDatas[config.dataSourceId]) {
        return
      }
      const datas = dataset2table(this.apiSourceDatas[config.dataSourceId])
      const markerData = datas.find(item => { return item[this.formInline.config.markerId] === this.formInline.dataId })
      this.formInline.markerName = markerData[this.formInline.config.namePropertyId]

      for (let i = 0; i < this.formInline.properties.length; i++) {
        const key = this.formInline.properties[i].key // 绑定的标注
        const value = markerData[key]
        this.$set(this.formInline.properties[i], 'value', value)
      }
      const postions = coordTransform(config.coordinatesType, [
        markerData[config.lonHeader],
        markerData[config.latHeader],
        markerData[config.heightHeader]
      ])
      this.formInline.pointLon = postions[0]
      this.formInline.pointLat = postions[1]
      this.formInline.pointHeight = postions[2]
      await this.$nextTick()
      if (this.$refs.detailContent) {
        this.$refs.detailContent.scrollTop = 0
      }
    },
    getLayerName (value) {
      if (!value || !this.layerList) return ''
      for (let i = 0; i < this.layerList.length; i++) {
        const item = this.layerList[i]
        if (item.id === value) {
          return item.name
        }
      }
      return ''
    },

    formatValue (item) {
      let value = '无'
      if (item.value === undefined || item.value === null) {
        return '无'
      }
      if (item.type === 'SELECT') {
        let keyValue = item.value
        if (item.multiSelect === false) {
          keyValue = [item.value]
        }
        if (keyValue && keyValue.length > 0) {
          value = ''
        }
        for (let j = 0; j < keyValue.length; j++) {
          const subKey = keyValue[j]
          for (let i = 0; i < item.options.length; i++) {
            if (item.options[i].id.toString() === subKey.toString()) {
              value += item.options[i].value
              if (j !== keyValue.length - 1) {
                value += ','
              }
            }
          }
        }
        return value
      } else if (item.type === 'NUMBER') {
        value = item.value ?? '无'
        if (item.unit) {
          value = item.value + item.unit
        }
      } else if (item.type === 'DATE') {
        value = '无'
        if (item.value) {
          if (isNaN(new Date(item.value).getTime())) {
            value = item.value
          } else {
            value = new Date(item.value).format('yyyy/MM/dd')
          }
        }
      } else if (item.type === 'DATE_TIME') {
        value = '无'
        if (item.value) {
          if (isNaN(new Date(item.value).getTime())) {
            value = item.value
          } else {
            value = new Date(item.value).format('yyyy/MM/dd hh:mm:ss')
          }
        }
      } else if (item.type === 'LINK') {
        value = this.detailModel ? '点击打开链接' : item.value
      } else if (item.type === 'LIVE') {
        value = '点击查看直播源'
      } else {
        value = item.value ?? '无'
      }
      return value
    },

    onClickItem (headerItem) {
      if (!headerItem.value || headerItem.value === '无') {
        return
      }
      if (headerItem.type === 'LIVE') {
        if (headerItem.value.indexOf('m3u8') >= 0 || headerItem.value.endsWith('flv') >= 0) {
          this.$emit('livePreviewMsg', { url: headerItem.value })
        } else {
          this.$Message('warning', '当前只支持m3u8， flv格式直播')
        }
      } else if (headerItem.type === 'LINK') {
        window.open(headerItem.value, '_target')
      }
    },
    clear () {
      // 标注类型
      this.markerType = undefined
      this.activeTab = 1
    },
    close () {
      this.visible = false
      this.clear()
      this.$emit('selectPrimitive', undefined)
      // this.$store.dispatch('selectMarker', undefined)
      // this.$emit('selectMapMarker', undefined)
    },
    // 图片预览
    onPreviewPic (item, index) {
      const list = JSON.parse(JSON.stringify(this.achievements))
      list.forEach(item => {
        item.format = item.type
      })
      this.$emit('previewPicMsg', {
        list: list,
        index: index
      })
    }
  }
}
</script>
<style lang="scss">
.apiMarkerAttribute{
  .el-form-item__content{
    margin-left: 100px;
  }
  .el-form-item__label{
    width: 105px;
    padding: 0 1px 0 0;
  }
  .el-form-item__label,
  .el-input__inner{
    font-size: 12px !important;
  }
  .el-progress-circle{
    width: 50px !important;
    height: 50px !important;
    svg{
      path:first-child {
        stroke: #666;
      }
    }
  }
  .el-progress__text{
    color: #fff;
  }
  .el-date-editor{
    .el-input__prefix{
      left:130px
    }
  }
  .formContainer{
    .el-form-item__error{
      margin-left: 10px;
    }
    .el-form-item__label{
      color: #999999;
    }
  }
  .point-item{
    .el-form-item{
      margin-bottom: 20px;
      .el-form-item__label{
        transform: translateX(4px);
      }
    }
  }
  .el-date-editor .el-input__suffix {
    right: 5px;
    height: 30px;
    background: #3e3f3f;
    transform: translateY(6px);
  }
  .el-select .el-input .el-input__inner{
    height: 32px !important;
  }
  .el-select .el-tag{
    max-width: 75px;
  }
}
</style>
<style lang="scss" scoped>
.apiMarkerAttribute {
  .tab-panel{
    width: 32px;
    .tab-header{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 32px;
      height: 74px;
      background: rgba(12, 12, 13, 0.6);
      border-radius: 6px 0px 0px 6px;
      padding: 5px;
      font-size: 14px;
      line-height: 1.1;
      margin: 10px 0;
      cursor: pointer;
      &.active{
        background: #00A4F0;
      }
    }
  }
  .top-tab{
    width: 280px;
    height: 32px;
    display: flex;
    flex-direction: row;
    .tab-header{
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid #464748;
      font-size: 14px;
      line-height: 32px;
      padding: 0 10px;
      cursor: pointer;
      min-width: 75px;
      border-radius: 6px;
      &.active{
        background: #00A4F0;
        border-color: #00A4F0;
      }
      // &:first-child {
      //   border-radius: 6px 0 0 6px;
      // }
      // &:last-child {
      //   border-radius: 0 6px 6px 0;
      // }
    }
  }
  .header{
    border-bottom: 1px solid #FFFFFF !important;
  }
  .footer {
    width: 100%;
    height: 50px;
    background: rgba(255, 255, 255, 0.05) !important;
    border-radius: 0px 0px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .left {
      width: 63px;
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
    }
    .right {
      width: 100%;
      text-align: right;
      .el-button{
        width: 80px;
        height: 32px;
      }
    }
  }
  .space-line{
    width: 260px;
    height: 1px;
    margin: 0 auto;
    margin-bottom: 20px;
    background-color: rgba($color: #ffffff, $alpha: 0.1) ;
  }
  .content {
    margin: 10px 0px;
    font-size: 12px !important;
    overflow-y: overlay;
    overflow-x: hidden;
    max-height: 380px;
    min-height: 200px;
    // &:hover{
    //   overflow-y: overlay;
    // }
    .tip {
      svg {
        width: 12px;
        height: 12px;
        font-size: 12px;
      }
      color: #999999;
      text-align: left;
      height: 49px;
    }
    .formContainer{
      max-height: 380px;
      overflow-y: hidden;
      padding: 0 20px;
      // .over-line .ant-form-item .ant-form-item-label {
      //   line-height: 17px;
      // }
      &:hover{
        overflow-y: overlay;
      }
      .attribute-item {
        width: 160px;
      }
    }
    .attribute-item2{
      margin-bottom: 10px;
      .title{
        display: inline-block;
        width: 90px;
        text-align: right;
        color: $font-color9;
        vertical-align: top;
        word-break: break-all;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .title2{
        display: inline;
        text-align: right;
        color: $font-color9;
        vertical-align: top;
        word-break: break-all;
        white-space:pre-wrap;
      }
      .value{
        display: inline-block;
        width: 160px;
        text-align: left;
        color: $font-colorf;
        word-break: break-all;
        white-space:pre-wrap;
        &.link{
          cursor: pointer;
          color: $primary-color;
          text-decoration: underline
        }
      }
    }
    .point-item{
      width: 280px;
      border: 1px solid rgba($color: #ffffff, $alpha: 0.06);
      border-radius: 10px;
      margin-left: -5px;
      margin-bottom: 22px;
      padding-top: 10px;
      &:last-child{
        margin-bottom: 0px;
      }
      .name-tag{
        width: 80px;
        height: 20px;
        background: linear-gradient(-60deg, #0971D2, #00A4F0);
        box-shadow: 0px 1px 4px 0px #001F3C;
        border-radius: 10px 10px 10px 0px;
        margin-top: -20px;
      }
    }
  }
  .custom-item{
    margin-bottom: 15px;
    .el-form-item__content{
      >div{
        transform: translateX(3px);
      }
      .custom-label{
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #999999;
        position: absolute;
        left: -100px;
        padding-left: 8px;
        text-align: right;
        transform: translateX(6px);
      }
    }
  }
}
</style>
